import styled from "styled-components"

export default styled.span`
font-size: 17px;
color: #98a0b3;
`
